var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-container"},[_vm._m(0),_c('div',{staticClass:"section-container"},[_c('pull-refresh-list',{attrs:{"list":_vm.list}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"section-title-line"},[_c('span',[_vm._v("集团新闻")])])
}]

export { render, staticRenderFns }